export default __webpack_public_path__ + "static/media/homewavetop.7907bff6.png";